import CookieWallModalView from './cookieWallModal.component.html';

class CookieWallModalController {
    constructor($scope) {
        'ngInject';

        this.$scope = $scope;

        this.showMoreCookieInfo = false;
        this.showMoreCookieDetails = false;

        this.cookie_necessary = true;
        this.cookie_analytical = false;
        this.cookie_advertising = false;
    }

    acceptCookies() {
        console.log('acceptCookies - 1');
        this.setCookie('acceptCookies', '1', 30);

        if (typeof (gtag) === 'function') {
            gtag('consent', 'update', {
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'ad_storage': 'granted',
                'analytics_storage': 'granted'
            });
        }

        this.close();
    }

    acceptSomeCookies() {
        if (this.cookie_analytical && this.cookie_advertising) {
            console.log('acceptCookies - 1');
            this.setCookie('acceptCookies', '1', 30);

            if (typeof (gtag) === 'function') {
                gtag('consent', 'update', {
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted',
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
            }
        } else if (this.cookie_analytical) {
            console.log('acceptCookies - 2');
            this.setCookie('acceptCookies', '2', 30);

            if (typeof (gtag) === 'function') {
                gtag('consent', 'update', {
                    'ad_user_data': 'denied',
                    'ad_personalization': 'denied',
                    'ad_storage': 'denied',
                    'analytics_storage': 'granted'
                });
            }
        } else if (this.cookie_advertising) {
            console.log('acceptCookies - 3');
            this.setCookie('acceptCookies', '3', 30);

            if (typeof (gtag) === 'function') {
                gtag('consent', 'update', {
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted',
                    'ad_storage': 'granted',
                    'analytics_storage': 'denied'
                });
            }
        } else {
            console.log('acceptCookies - 4');
            this.setCookie('acceptCookies', '4', 30);
        }

        this.close();
    }

    setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }
}

let cookieWallModalComponent = {
    bindings: {},
    template: CookieWallModalView,
    controller: CookieWallModalController
};

export default cookieWallModalComponent;
